import { Divider } from "antd";

import { BTCard } from "commonComponents/btWrappers/BTCard/BTCard";
import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import { BTTitle } from "commonComponents/btWrappers/BTTitle/BTTitle";
import {
    DateLineLabel,
    NameLineLabel,
    SignatureLineLabel,
} from "commonComponents/entity/media/signatures/common/signatures.utility";
import { PrintBreakAvoid } from "commonComponents/print/PrintBreakAvoid/PrintBreakAvoid";
import { PrintSignature } from "commonComponents/print/PrintSignature/PrintSignature";
import { DateDisplayDate } from "commonComponents/utilities/DateDisplay/DateDisplayDate";

import "./SignatureDisplay.less";

export const approvalStatuses = ["pending", "approved", "declined"] as const;

export type ApprovalStatusType = (typeof approvalStatuses)[number];

export interface ISignatureDisplayProps {
    signaturePath?: string | null;
    signatureDate?: Date | null;
    signatureUserName?: string | null;
    reason?: string | null;
    /**
     * @default "pending"
     */
    approvalStatusType?: ApprovalStatusType;
    /**
     * @default true
     */
    lazyLoad?: boolean;
}

function SignatureDisplay(props: ISignatureDisplayProps) {
    return (
        <PrintBreakAvoid>
            <BTCard className="FullSignatureDisplay" data-testid="signature-display">
                <BTRow gutter={24} className="SignatureRow">
                    <BTCol span={8} data-testid="signature-row-signature-column">
                        <>
                            {props.approvalStatusType === "declined" && (
                                <span className="SignatureDeclined">Declined</span>
                            )}
                            {props.approvalStatusType === "approved" && props.signaturePath && (
                                <PrintSignature
                                    url={props.signaturePath}
                                    className="Signature"
                                    lazyLoad={props.lazyLoad}
                                />
                            )}
                        </>
                    </BTCol>
                    <BTCol span={8} data-testid="signature-row-name-column">
                        {(props.approvalStatusType === "approved" ||
                            props.approvalStatusType === "declined") && (
                            <span className="SignatureName">{props.signatureUserName}</span>
                        )}
                    </BTCol>
                    <BTCol span={8} data-testid="signature-row-date-column">
                        {(props.approvalStatusType === "approved" ||
                            props.approvalStatusType === "declined") &&
                            props.signatureDate && (
                                <DateDisplayDate
                                    data-testid="signature-date-display"
                                    value={props.signatureDate}
                                    className="SignatureDate"
                                    showTime
                                />
                            )}
                    </BTCol>
                </BTRow>
                <BTRow gutter={24} className="LabelRow">
                    <BTCol span={8} data-testid="label-row-signature-column">
                        <Divider className="SignatureLine" />
                        <BTTitle level={4}>{SignatureLineLabel}</BTTitle>
                    </BTCol>
                    <BTCol span={8} data-testid="label-row-name-column">
                        <Divider className="SignatureLine" />
                        <BTTitle level={4}>{NameLineLabel}</BTTitle>
                    </BTCol>
                    <BTCol span={8} data-testid="label-row-date-column">
                        <Divider className="SignatureLine" />
                        <BTTitle level={4}>{DateLineLabel}</BTTitle>
                    </BTCol>
                </BTRow>
                {props.approvalStatusType !== "pending" && props.reason !== undefined && (
                    <BTRow className="ReasonRow" data-testid="signature-reason-row">
                        <BTCol span={24}>{props.reason && <span>{props.reason}</span>}</BTCol>
                    </BTRow>
                )}
            </BTCard>
        </PrintBreakAvoid>
    );
}

export default SignatureDisplay;
